import { all, fork } from 'redux-saga/effects'

import SecuritySagas from 'core/Security/sagas'

export default function* rootSaga() {
  yield all([fork(SecuritySagas)])
}
